/**
 * @function getSearchParams
 * Used to return the correct search params (if exist) when using Browser or Hash router
 * When using BrowserRouter search params are set in the location.search
 * and when using HashRouter location.search is '' and search params are the part of the location.hash.
 * @return {URLSearchParams}
 */
export function getSearchParams({ withQuestionMark = false } = {}): URLSearchParams {
	let searchParams = '';
	if (globalThis.location.search) {
		searchParams = globalThis.location.search;
	} else if (globalThis.location.hash && globalThis.location.hash.indexOf('?') !== -1) {
		searchParams = globalThis.location.hash.substring(
			globalThis.location.hash.indexOf('?'),
			globalThis.location.hash.length
		);
	}

	const params = new URLSearchParams(searchParams);
	const _toString = params.toString.bind(params);

	params.toString = () => {
		return `${withQuestionMark ? '?' : ''}${_toString()}`;
	};

	return params;
}
